import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchApplicationFunctions } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ApplicationFunctionListPage() {
  const { businessDomainId, categoryId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [rows, setRows] = useState([]);

  const basePath = `/strategy/${businessDomainId}/application-categories/${categoryId}`;

  const loadData = useCallback(async () => {
    try {
      const data = await fetchApplicationFunctions(categoryId);
      setRows(Array.isArray(data) ? data.map((f) => ({ id: f.applicationFunctionId, ...f })) : []);
    } catch (e) { notify.apiError(e); }
  }, [categoryId]);

  useEffect(() => { loadData(); }, [loadData]);

  const columns = [
    { field: "applicationFunctionName", headerName: t("applicationCategory.applicationFunctionName"), flex: 1, minWidth: 200 },
    { field: "applicationTaskName", headerName: t("applicationCategory.applicationTaskName"), flex: 1, minWidth: 150 },
    {
      field: "url",
      headerName: t("common.url"),
      flex: 1,
      minWidth: 200,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}>
            {params.value}
          </a>
        ) : null,
    },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("applicationCategory.applicationFunctions")}</Typography>
        <Button variant="contained" startIcon={<AddIcon />}
          onClick={() => navigate(`${basePath}/application-functions/add`)}>
          {t("common.add")}
        </Button>
      </Box>

      <Box sx={{ height: 400 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableRowSelectionOnClick
          hideFooterSelectedRowCount
          onRowClick={(params) => navigate(`${basePath}/application-functions/${params.row.applicationFunctionId}`)}
          sx={{ cursor: "pointer" }}
        />
      </Box>

      <Box sx={{ mt: 2 }}>
        <Button variant="outlined" onClick={() => navigate(basePath)}>{t("common.back")}</Button>
      </Box>

    </Box>
  );
}
